<template>
    <div class="mt-5">
      <div class="input-box-holder mt-8" v-validate="errors" v-has-value="address.street">
        <SelectField
          class="input-box"
          title='Street'
          :options="$store.state.streets"
          :value="getStreet"
          @input="setStreet"
          @inputCustom="setCustomStreet"
          :without-icon="true"
          required
        />
        <div class="validation-output text-left mt-2">
          <ErrorHandler class="error" :id="`V037_${index}`">
            Enter the street.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V154_${index}`">
            The maximum number of characters is 30.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V202_${index}`">
            Enter the street in the correct format.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V113_${index}`">
            Enter the street.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V178_${index}`">
            The maximum number of characters is 30.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V205_${index}`">
            Enter the street in the correct format.
          </ErrorHandler>
        </div>
      </div>

      <div class="input-box-holder mt-10" v-validate="errors" v-has-value="address.streetNumber">
        <TextField
          class="input-box"
          title='House Number'
          v-model="address.streetNumber"
          required
        />
        <div class="validation-output text-left mt-2">
          <ErrorHandler class="error" :id="`V038_${index}`">
            Enter the house number.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V155_${index}`">
            The maximum number of characters is 10.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V232_${index}`">
            Enter the house number in the correct format.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V114_${index}`">
            Enter the house number.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V179_${index}`">
            The maximum number of characters is 10.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V236_${index}`">
            Enter the house number in the correct format.
          </ErrorHandler>
        </div>
      </div>

      <div class="input-box-holder mt-8" v-validate="errors" v-has-value="address.city">
        <SelectField
          class="input-box"
          title='City'
          :options="$store.state.cities"
          :value="getCity"
          @input="setCity"
          :without-icon="true"
          required
        />
        <div class="validation-output text-left mt-2">
          <ErrorHandler class="error" :id="`V036_${index}`">
            Enter the city.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V156_${index}`">
            The maximum number of characters is 30.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V112_${index}`">
            Enter the city.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V180_${index}`">
            The maximum number of characters is 30.
          </ErrorHandler>
        </div>
      </div>

      <div class="input-box-holder mt-10" v-validate="errors" v-has-value="address.zip">
        <TextField
          class="input-box"
          title='Postcode'
          required
          v-model="address.zip"
        />
        <div class="validation-output text-left mt-2">
          <ErrorHandler class="error" :id="`V039_${index}`">
            Enter postcode.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V157_${index}`">
            <span>The maximum number of characters is 5.</span>
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V115_${index}`">
            Enter postcode.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V181_${index}`">
            <span>The maximum number of characters is 5.</span>
          </ErrorHandler>
        </div>
      </div>

      <div class="input-box-holder mt-8" v-validate="errors" v-has-value="address.country">
        <SelectField
          class="input-box"
          title='Country'
          :options="$store.state.countries"
          v-model="address.country"
          :disabled="true"
          required
          valueOnlyFromOptions
        />
        <div class="validation-output text-left mt-2">
          <ErrorHandler class="error" :id="`V040_${index}`">
            Select country.
          </ErrorHandler>

          <ErrorHandler class="error" :id="`V116_${index}`">
            Select country.
          </ErrorHandler>
        </div>
      </div>
    </div>
</template>
<script>
import SelectField from '@/components/SelectField/SelectField.vue';
import TextField from '@/components/TextField/TextField.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';

export default {
  components: { TextField, SelectField, ErrorHandler },
  data() {
    return {
      slovakia: {
        area: 'SK',
        areaName: 'Slovenská republika',
        calcKey: '4',
        label: 'Slovenská republika',
        name$: '703',
        optgroup: false,
        search: 'slovenska republika',
        value: 703,
      },
    };
  },
  props: {
    address: { type: Object, required: true },
    errors: { type: Array, required: true },
    index: { type: Number, required: true },
    person: { type: Object, required: true },
  },
  mounted() {
    if (!this.address.country) {
      this.setCountry(this.slovakia);
    }
  },
  computed: {
    getStreet() {
      if (this.address) {
        return {
          label: this.address.street,
        };
      }
      return null;
    },
    getCity() {
      if (this.address) {
        return {
          label: this.address.city,
        };
      }
      return null;
    },
  },
  methods: {
    setCountry(value) {
      this.address.country = value;
    },
    setCity(value) {
      if (value) {
        this.address.city = value.label;
      } else {
        this.address.city = null;
      }
    },
    setStreet(value) {
      if (value) {
        this.address.street = value.label;
      } else {
        this.address.street = null;
      }
    },
    setCustomStreet(value) {
      if (value) {
        this.address.street = value;
      } else {
        this.address.street = null;
      }
    },
  },
};
</script>
